import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
declare var $: any;
import * as _ from 'lodash';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-allotees-new',
  templateUrl: './allotees-new.component.html',
  styleUrls: ['./allotees-new.component.css']
})
export class AlloteesNewComponent implements OnInit {

  @Input('allotteeId') allotteeId: any;
  @Input('allotteeStatus') allotteeStatus: any;
  @Input('issueDetails') issueDetails: any;

  alloteesForm: FormGroup;
  btnadd: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  dpTypeList = ['NSDL', 'CDSL'];
  existingAllotteesInvestorCodeList: any = [];
  isInvestorCodeValid: boolean;
  isInvestorCodeUnique: boolean;
  investorCodeArray: any = [];
  disabledOnclick: boolean;

  constructor(private ncdClientService: NcdclientService, private alert: AlertComponent,
     private fb: FormBuilder, public activeModal: NgbActiveModal) { }

  ngOnInit() {

    if (this.allotteeId == null) {
      this.btnadd = true;
    } else {
      this.btnadd = false;
    }

    this.alloteesForm = new FormGroup({
      investorCodeSelection: new FormControl('existing', []),
      srNo: new FormControl('', []),
      investorCode: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', []),
      addressLine2: new FormControl('', []),
      addressLine3: new FormControl('', []),
      city: new FormControl('', []),
      state: new FormControl('', []),
      country: new FormControl('', []),
      pinCode: new FormControl('', []),
      email: new FormControl('', []),
      mobile: new FormControl('', []),
      PAN: new FormControl('', []),
      investorCategory: new FormControl('', []),
      investorSubCategory: new FormControl('', []),
      bankName: new FormControl('', []),
      IFSC: new FormControl('', []),
      virtualAccountNo: new FormControl('', []),
      dpType: new FormControl('', []),
      dpID: new FormControl('', []),
      benCliId: new FormControl('', []),
      allotteesDynamicFieldsArray: this.fb.array([this.multiOptionBasedDynamicFieldsFormGroup()])
    });


    this.getExistingAllotteesInvestorCodeList();

    var resData = this.issueDetails;
    this.getAlloteeDetails(resData);

  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }
  

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  multiOptionBasedDynamicFieldsFormGroup(): FormGroup {
    return this.fb.group({
      payinAmount: ['', []],
      payoutQuantity: ['', []],
    });
  }

  addNewFieldsBlock() {
    (<FormArray>this.alloteesForm.get('allotteesDynamicFieldsArray')).push(this.multiOptionBasedDynamicFieldsFormGroup());
  }

  closeModal() {
    this.activeModal.close();
  }

  changeInvestorCodeSelection() {
    this.alloteesForm.controls.investorCode.setValue('');;
    this.isInvestorCodeUnique = false;
  }

  onBlurCheckInvestorCode() {
    let investorCode = this.alloteesForm.controls.investorCode.value;

    if (this.investorCodeArray.includes(investorCode)) {
      this.isInvestorCodeUnique = true;
    } else {
      this.isInvestorCodeUnique = false;
    }
  }

  clearAllDataForNewAllottee(){
    this.alloteesForm.reset();
    this.alloteesForm.controls.investorCodeSelection.setValue('new');
    this.emailTagsInput();
  }

  getExistingAllotteesInvestorCodeList() {
    this.ncdClientService.getExistingAllotteesList()
      .subscribe(response => {

        if (response.status == 0) {
          this.existingAllotteesInvestorCodeList = response.data;
          var self = this;
          response.data.forEach(function (o) {
            self.investorCodeArray.push(o.investorCode);
          });
        } else {
          // this.alert.error(response.message);
        }
      });
  }

  emailTagsInput() {
    $(document).ready(function() {
    $('.email').tagsInput({
      'unique': true,
      'interactive': true,
      'width': 'auto',
      'height': 'auto',
      'onAddTag': function (input, value) {

        if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}/.test(value))) {
          // console.log('------if-----------------', value)
          $('.email').removeTag(value);
        } else {

        }
      }
    })
    $('.email').importTags('');
  })
  }

  fetchAllotteeDetailsByInvestorCode(ev) {

    let selectedIndex = ev.target.selectedIndex - 1;
    let allotteeId = $("#hiddenAlloteeId" + selectedIndex).val();
    let investorCode = ev.target.value;
    this.emailTagsInput();
    // console.log("investorCodeObj++++++++++++++++++++++++",investorCodeObj);
    // console.log("this.issueDetails._id++++ev++++++++++++++++++++",ev.target.selectedIndex);

    this.ncdClientService.getDetailsFromMasterByInvestorCode(allotteeId, investorCode)
      .subscribe(res => {
        if (res.status == 0) {

           // Removing all dynamic controls
           const formArrayNewField: FormArray = <FormArray>this.alloteesForm.get('allotteesDynamicFieldsArray');
           
          //  while (formArrayNewField.length !== 0) {
          //    formArrayNewField.controls = [];
          //    formArrayNewField.value
          //  }
 
           for (let i = 0; i < formArrayNewField.value.length; i++) {
             $("#payinAmount" + i).val('');
             $("#payoutQuantity" + i).val('');
            //  this.addNewFieldsBlock();
            formArrayNewField.value[i].payinAmount = '';
            formArrayNewField.value[i].payoutQuantity = '';
           }

          var selectedAlloteeDetails = res.data;
          $(".email").importTags(selectedAlloteeDetails.email);
          this.alloteesForm.patchValue({
            investorCodeSelection: 'existing',
            srNo: selectedAlloteeDetails.srNo,
            investorCode: selectedAlloteeDetails.investorCode,
            name: selectedAlloteeDetails.name,
            addressLine1: selectedAlloteeDetails.addressLine1,
            addressLine2: selectedAlloteeDetails.addressLine2,
            addressLine3: selectedAlloteeDetails.addressLine3,
            city: selectedAlloteeDetails.city,
            state: selectedAlloteeDetails.state,
            country: selectedAlloteeDetails.country,
            pinCode: selectedAlloteeDetails.pinCode,
            email: selectedAlloteeDetails.email,
            mobile: selectedAlloteeDetails.mobile,
            PAN: selectedAlloteeDetails.PAN,
            investorCategory: selectedAlloteeDetails.investorCategory,
            investorSubCategory: selectedAlloteeDetails.investorSubCategory,
            bankName: selectedAlloteeDetails.bankName,
            IFSC: selectedAlloteeDetails.IFSC,
            virtualAccountNo: selectedAlloteeDetails.virtualAccountNo,
            dpType: selectedAlloteeDetails.dpType,
            dpID: selectedAlloteeDetails.dpID,
            benCliId: selectedAlloteeDetails.benCliId,
          })

         

          // var count = 0;
          // var self = this;
          // console.log("this.issueDetails.MultiOption+++++++++++++",this.issueDetails.MultiOption);
          // _.forEach(self.issueDetails.MultiOption, function (multiOptionBasedFields) {
          //   const formArray: FormArray = <FormArray>self.alloteesForm.get('allotteesDynamicFieldsArray');
          //   formArray.push(self.multiOptionBasedDynamicFieldsFormGroup());
          //   var formGroup: FormGroup = <FormGroup>formArray.controls[count];
          // 
          //   console.log("formArrayNewField.payinAmount+++++++++++++",formGroup.controls.payinAmount.value);
          //   // formGroup.controls._id.setValue(multiOptionBasedFields._id);
          //   formGroup.controls.payinAmount.setValue('');
          //   formGroup.controls.payoutQuantity.setValue(' ');

          //   // formGroup.controls._id.updateValueAndValidity()
          //   formGroup.controls.payinAmount.updateValueAndValidity()
          //   formGroup.controls.payoutQuantity.updateValueAndValidity()
          //   console.log("formArrayNewField.controls+++++++++++++",formGroup);
          //   count++;
          // })
          
        }
        else {
           // if (res.errFields) {
          //   this.alert.error(JSON.stringify(res.errFields) + ' fields are required');
          // } else if (res.error) {
          //   this.alert.error(JSON.stringify(res.error) + ' fields are required');
          // } else {
          //   this.alert.error(res.message);
          // }
        }
      });
  }

  getAlloteeDetails(allotteesTabsDetails) {


    this.emailTagsInput();
    if (this.allotteeId != null) {
      let alloteeList = allotteesTabsDetails.Allottees;
      let allotteeById = alloteeList.filter(allottee => allottee._id === this.allotteeId);

      // this.multipleEmails = allotteeById[0].email;

      $(".email").importTags(allotteeById[0].email);

      this.alloteesForm.patchValue({
        investorCodeSelection: allotteeById[0].investorCodeSelection,
        srNo: allotteeById[0].srNo,
        investorCode: allotteeById[0].investorCode,
        name: allotteeById[0].name,
        addressLine1: allotteeById[0].addressLine1,
        addressLine2: allotteeById[0].addressLine2,
        addressLine3: allotteeById[0].addressLine3,
        city: allotteeById[0].city,
        state: allotteeById[0].state,
        country: allotteeById[0].country,
        pinCode: allotteeById[0].pinCode,
        email: allotteeById[0].email,
        mobile: allotteeById[0].mobile,
        PAN: allotteeById[0].PAN,
        investorCategory: allotteeById[0].investorCategory,
        investorSubCategory: allotteeById[0].investorSubCategory,
        bankName: allotteeById[0].bankName,
        IFSC: allotteeById[0].IFSC,
        virtualAccountNo: allotteeById[0].virtualAccountNo,
        dpType: allotteeById[0].dpType,
        dpID: allotteeById[0].dpID,
        benCliId: allotteeById[0].benCliId,
      })

      // this.alloteesForm.controls.dpType.setValue(allotteeById[0].dpType);
      // Dynamic Controls
      // Removing all dynamic controls
      const formArrayNewField: FormArray = <FormArray>this.alloteesForm.get('allotteesDynamicFieldsArray');
      while (formArrayNewField.length !== 0) {
        formArrayNewField.controls = [];
      }

      var count = 0;
      var self = this;
      _.forEach(allotteeById[0].allotteesDynamicFieldsArray, function (multiOptionBasedFields) {
        const formArray: FormArray = <FormArray>self.alloteesForm.get('allotteesDynamicFieldsArray');
        formArray.push(self.multiOptionBasedDynamicFieldsFormGroup());
        var formGroup: FormGroup = <FormGroup>formArray.controls[count];

        // formGroup.controls._id.setValue(multiOptionBasedFields._id);
        formGroup.controls.payinAmount.setValue(multiOptionBasedFields.payinAmount);
        formGroup.controls.payoutQuantity.setValue(multiOptionBasedFields.payoutQuantity);

        // formGroup.controls._id.updateValueAndValidity()
        formGroup.controls.payinAmount.updateValueAndValidity()
        formGroup.controls.payoutQuantity.updateValueAndValidity()

        count++;
      })


      if (allotteeById[0].allotteesDynamicFieldsArray.length < allotteesTabsDetails.MultiOption.length) {
        var remainingdynamicCount = allotteesTabsDetails.MultiOption.length - allotteeById[0].allotteesDynamicFieldsArray.length;
        for (let i = 0; i < remainingdynamicCount; i++) {
          this.addNewFieldsBlock();
        }
      }

    } else {
      // Removing all dynamic controls
      const formArrayNewField: FormArray = <FormArray>this.alloteesForm.get('allotteesDynamicFieldsArray');
      while (formArrayNewField.length !== 0) {
        formArrayNewField.controls = [];
      }

      for (let i = 0; i < allotteesTabsDetails.MultiOption.length; i++) {
        this.addNewFieldsBlock();
      }
    }

  }

  allotteeFormObjectForsaveAndUpdate(type) {
    this.disabledOnclick = true;

    let allotteesDetails = {
      issueID: this.issueDetails._id,
      investorCodeSelection: this.alloteesForm.controls.investorCodeSelection.value,
      srNo: this.alloteesForm.controls.srNo.value,
      investorCode: this.alloteesForm.controls.investorCode.value,
      name: this.alloteesForm.controls.name.value,
      addressLine1: this.alloteesForm.controls.addressLine1.value,
      addressLine2: this.alloteesForm.controls.addressLine2.value,
      addressLine3: this.alloteesForm.controls.addressLine3.value,
      city: this.alloteesForm.controls.city.value,
      state: this.alloteesForm.controls.state.value,
      country: this.alloteesForm.controls.country.value,
      pinCode: this.alloteesForm.controls.pinCode.value,
      email: $('.email').val(),
      mobile: this.alloteesForm.controls.mobile.value,
      PAN: this.alloteesForm.controls.PAN.value,
      investorCategory: this.alloteesForm.controls.investorCategory.value,
      investorSubCategory: this.alloteesForm.controls.investorSubCategory.value,
      bankName: this.alloteesForm.controls.bankName.value,
      IFSC: this.alloteesForm.controls.IFSC.value,
      virtualAccountNo: this.alloteesForm.controls.virtualAccountNo.value,
      dpType: this.alloteesForm.controls.dpType.value,
      dpID: this.alloteesForm.controls.dpID.value,
      benCliId: this.alloteesForm.controls.benCliId.value,
      allotteesDynamicFieldsArray: this.alloteesForm.controls.allotteesDynamicFieldsArray.value
    }

    if (this.allotteeId == null) {
      this.ncdClientService.addAllottees(allotteesDetails)
        .subscribe((res:any) => {
          this.disabledOnclick = false;
          this.closeModal();
          if (res.status == 0) {
            this.alert.success("NCD allottees added successfully.");
          }
          else {
            if (res.err_fields) {
              this.alert.error(JSON.stringify(res.err_fields) + '  fields are required or invalid');
            } else if (res.error) {
              this.alert.error(JSON.stringify(res.error) + '  fields are required or invalid');
            } else {
              this.alert.error(res.message);
            }
          }
        });
    } else {
      this.ncdClientService.updateAllottees(allotteesDetails, this.allotteeId)
        .subscribe((res:any) => {
          this.disabledOnclick = false;
          this.closeModal();
          if (res.status == 0) {
            this.alert.success("NCD allottees updated successfully.");
          }
          else {
            if (res.err_fields) {
              this.alert.error(JSON.stringify(res.err_fields) + ' fields are required or invalid or Readonly.');
            } else if (res.error) {
              this.alert.error(JSON.stringify(res.error) + ' fields are required or invalid or Readonly. ');
            } else {
              this.alert.error(res.message);
            }
          }
        });
    }

  }

}

